import { JsonObject } from "json2typescript";
import { ClientDataLoginInterface } from "../interfaces/client-data-login.interface";

@JsonObject("ClientDataLoginModel")
export class ClientDataLoginModel implements ClientDataLoginInterface {
    Domain?: string;
    IsEnableAccount?: boolean;
    Language?: string;
    RolName?: string;
    SessionToken?: string;
    UserCode?: string;
    UserId?: string;
    ClientCode?: string;
    ClientId?: string;

    constructor(obj?: any) {
        Object.assign(this, obj);
    }
}
